export const getCollaboratorInitialState = {
	collaborators: undefined,
	loading: false,
	error: null,
	errorShow: false,
	getData: false,
};
